import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

import { SingleSelectDropdown, DROPDOWN_TYPE } from "widgets/singleselect";

import { Base } from "../base";
import { SingleSelect as SingleSelectReadOnly } from "../../renderers/singleselect";

import styles from "./singleselect.css";

export function SingleSelect(props) {
  const { column, value, pos, row } = props;
  const baseRef = useRef(null);
  const selectRef = useRef(null);
  const [currentValue, setCurrentValue] = useState(value);
  // const [dataSource, setDataSource] = useState([]);

  useEffect(
    function setValue() {
      setCurrentValue(value || null);
      // selectRef.current && selectRef.current.blur();
    },
    [value, row, pos]
  );

  const fetchData = (value, row) => {
    return (pageNo = 1, queryStr = "") =>
      column.dataSource({ value, row, pageNo, queryStr });
  };

  return (
    <Base
      {...props}
      ref={baseRef}
      onEditing={(e) => {}}
      type="select"
      className={styles.singleSelectBase}
    >
      {column.readOnly && (
        <SingleSelectReadOnly value={value} column={column} />
      )}
      {!column.readOnly && (
        <SingleSelectDropdown
          value={currentValue}
          dataSource={fetchData(value, row)}
          onOpen={({ loadDataSource }) => {
            baseRef.current.startEditing(currentValue);
            loadDataSource();
            selectRef.current.focus();
          }}
          ref={selectRef}
          onChange={(value) => {
            selectRef.current && selectRef.current.blur();
            setTimeout(() => {
              selectRef.current && selectRef.current.focus();
              baseRef.current.startEditing(currentValue);
              baseRef.current.dataChanged(value === undefined ? null : value);
              baseRef.current.dataCompleted();
            }, 100);
          }}
          onSearch={({ search, listOptions }) =>
            column.onSearch({
              search,
              value: currentValue,
              row,
              column,
              listOptions
            })
          }
          checkDataSourceForValue={false}
          type={DROPDOWN_TYPE.MINIMAL}
          className={styles.singleselect}
          defer={true}
        />
      )}
    </Base>
  );
}

SingleSelect.propTypes = {
  value: PropTypes.any,
  column: PropTypes.any,
  pos: PropTypes.any,
  row: PropTypes.any
};
